import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alumni-speak',
  templateUrl: './alumni-speak.component.html',
  styleUrls: ['./alumni-speak.component.scss']
})
export class AlumniSpeakComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
